import {
  OutlinedInput,
  Select as MuiSelect,
  SelectProps as MuiSelectProps,
  Theme,
} from '@mui/material';

interface SelectProps {
  children: MuiSelectProps['children'];
  selectedOptions: MuiSelectProps['value'];
  isOpened?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  onChange?: MuiSelectProps['onChange'];
  title: string;
  isMultiselect?: boolean;
  fullSize?: boolean;
  isFormInput?: boolean;
  sx?: MuiSelectProps['sx'];
  error?: boolean;
}

export const Select = ({
  children,
  selectedOptions,
  isOpened,
  onOpen,
  onClose,
  onChange,
  title,
  isMultiselect = false,
  fullSize = false,
  isFormInput = false,
  sx,
  error,
}: SelectProps) => (
  <MuiSelect
    sx={[
      styles(isFormInput).dropdownCategory,
      fullSize && { width: '100% !important', height: '46px !important' },
      isFormInput && { height: '40px !important' },
      ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
    ]}
    value={selectedOptions}
    renderValue={() => title}
    inputProps={{
      'aria-label': title,
    }}
    multiple={isMultiselect}
    displayEmpty
    input={<OutlinedInput />}
    open={isOpened}
    onOpen={onOpen}
    onClose={onClose}
    onChange={onChange}
    error={error}
    MenuProps={{
      MenuListProps: {
        sx: {
          padding: 0,
          maxHeight: 400,
        },
      },
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left',
      },
    }}>
    {children}
  </MuiSelect>
);

const styles = (isFormInput: boolean) => ({
  dropdownCategory: {
    borderRadius: 1.5,
    height: {
      xs: 46,
      sm: 33,
    },
    width: {
      xs: '100%',
      sm: 'auto',
    },
    '& .MuiInputBase-input': (theme: Theme) =>
      isFormInput ? theme.typography.body2 : theme.typography.select,
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: isFormInput ? 'grey200' : 'secondary.main',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: isFormInput ? 'grey200' : 'secondary.main',
    },
  },
});
